// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-L":"L_outdoor-recreation-L__V18N_"};